<script lang="ts">
  import { isUserRoleADM } from "../../app.store";
  import MainMenuItem from "./MainMenuItem.svelte";
</script>

<div class="main-menu noselect">
  <aside class="menu">
    <p class="menu-label">Menu</p>

    <ul class="menu-list">
      <MainMenuItem link="/dashboard" label="Dashboard" icon="leaderboard" />
      <MainMenuItem link="/score" label="Scores" icon="emoji_events" />
      <MainMenuItem link="/task" label="Problems" icon="device_hub" />
    </ul>

    {#if $isUserRoleADM}
      <p class="menu-label">Administration</p>

      <ul class="menu-list">
        <MainMenuItem link="/user" label="Users" icon="group" />
        <MainMenuItem link="/classroom" label="Classrooms" icon="school" />
        <MainMenuItem link="/section" label="Sections" icon="label" />
        <MainMenuItem link="/challenge" label="Challenges" icon="terminal" />
        <MainMenuItem link="/submission" label="Submissions" icon="task" />
        <!-- <MainMenuItem link="/settings" label="Settings" icon="settings" /> -->
      </ul>
    {/if}
  </aside>
</div>
